import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import Brokers from './Brokers'
import Comparison from './Comparison'
import { connect } from "react-redux";
import { logPageView } from '../../../utils/emfLogs';
import { Pages } from '../../../utils/loggerConstants';
import { pageLoadLogs } from '../../../utils/loggerUtils';

class AvailableBrokers extends Component {

  componentDidMount(){
    console.log("Mounted Broker")
    logPageView(Pages.Broker)
    pageLoadLogs(navigator.userAgent, Pages.Broker)

    document.title = this.props.t('Header.Title') + " " + this.props.t('Navigation.StockAwardLabel')
    document.getElementById('main-h1').innerHTML = this.props.t('Header.Title') + " " + this.props.t('Navigation.BrokerLabel')
  }

  render() {
    return (
      <div>
        <Brokers/>
        <Comparison/>
      </div>
    )
  }
}

export default connect()(withTranslation("translations")(AvailableBrokers));
